import useSWR, { type SWRConfiguration } from "swr";
import { simpleFetcher } from "~/api/fetcher";

type OnboardingState =
  | "pending_admin_consent"
  | "pending_container_registration"
  | "pending_container_creation"
  | "container_ready"
  | "pending_migration"
  | "migration_in_progress"
  | "completed";

export interface MicrosoftIntegration {
  clientId: string;
  hasLegacyProvider: boolean;
  hasAccessToken: boolean;
  state: OnboardingState;
  migration: {
    totalCount: number;
    completedCount: number;
    failedCount: number;
  };
}

export function useMicrosoftIntegration(
  token: string | null,
  config?: SWRConfiguration,
) {
  return useSWR<MicrosoftIntegration | null, Error>(
    token ? `/api/v2/onboarding/microsoft/${token}` : null,
    simpleFetcher,
    config,
  );
}
